import { render, staticRenderFns } from "./ProjectGridItem.vue?vue&type=template&id=4163162a"
import script from "./ProjectGridItem.vue?vue&type=script&lang=js"
export * from "./ProjectGridItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports